import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import '../styles/ParallaxModal.css';
import LoadingFallback from './LoadingFallback';
const ProductMagnifiedGallery = React.lazy(() => import('./ProductMagnifiedGallery'));
/**
 * This component will be used to display the image of the product in model
 */
const ParallaxModel = ({ show, onClose, onClick, images, productTitle, index, isImage, modelIndex, isModel, models }) => {
    if (!show) {
        return null;
    }

    return (
        <button
            className={'parallax-model'}
            onClick={onClose}
            aria-label={'Close modal'}>
            <button
                className={'parallax-model--content'}
                onClick={onClick}
                aria-label={'Modal content'}>
                <Suspense
                    fallback={<LoadingFallback />}
                >
                    <ProductMagnifiedGallery
                        index={index}
                        onClose={onClose}
                        productTitle={productTitle}
                        images={images}
                        isImage={isImage}
                        isModel={isModel}
                        models={models}
                        modelIndex={modelIndex} />
                </Suspense>
            </button>
        </button>
    );
};

ParallaxModel.propTypes = {
    index: PropTypes.number,
    productTitle: PropTypes.string,
    onClick: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    images: PropTypes.array,
    isImage: PropTypes.bool,
    isModel: PropTypes.bool,
    modelIndex: PropTypes.number,
    models: PropTypes.array
};


export default ParallaxModel;